import { render } from "./RegistrationCompleteView.vue?vue&type=template&id=9de07d6a"
import script from "./RegistrationCompleteView.vue?vue&type=script&lang=js"
export * from "./RegistrationCompleteView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projekty\\www\\cdif3com\\rental\\source\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__